import { useStore } from "@nanostores/preact";
import { $playerPos } from "../state/stores";
import { type Cell, townViewBox } from "../world/townMap";

const FILL: Record<Cell["state"], string> = { mine: "#f2b54a", taken: "#8a7a66", free: "#e9dcc0" };

/** Top-down town: lots, the library and plaza, and the player. Clicking any lot calls onPick; the selected one is outlined. */
export function TownMap(props: { cells: Cell[]; selected?: string | null; onPick(id: string): void }) {
  const pos = useStore($playerPos);
  return (
    <svg class="town-map" viewBox={townViewBox(props.cells).join(" ")} width="100%" role="img" aria-label="小鎮地圖">
      <rect x={-16} y={-37} width={32} height={29} fill="#b98a5a" />
      <circle cx={0} cy={0} r={10} fill="#cdbb98" />
      {props.cells.map((c) => {
        const sel = c.id === props.selected;
        return (
          <rect key={c.id} data-lot={c.id} data-state={c.state} data-selected={sel ? "true" : undefined}
            x={c.x} y={c.y} width={c.w} height={c.h} fill={FILL[c.state]}
            stroke={sel ? "#ffffff" : "#5a4a3a"} stroke-width={sel ? 1.2 : 0.4} style={{ cursor: "pointer" }}
            onClick={() => props.onPick(c.id)}>
            <title>{c.id}</title>
          </rect>
        );
      })}
      <circle cx={pos.x} cy={-pos.z} r={2} fill="#d0452f" />
    </svg>
  );
}
